import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');

export default class UserProjects extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		
// 		let parms = JSON.stringify(querystring.parse(this.props.location.search));
        let	parms = parms.replace('?','');

	
		this.state = {
			contentId : JSON.parse(parms).id,
			content : {
			}
		};
		//this.handleDelete = this.handleDelete.bind(this);
	}
	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
		console.log('cid = ' + this.state.contentId);
  		axios.get(`${global.config.apiServicesUrl}/contents${this.state.contentId}`).then(res => {
	 	this.setState({content : res.data });
		console.log(this.state.content);
				
		});
			

			
		
	
	}
	handleChange = (event) => {
	
	}

	handleDelete = (id, event) => {

	}

	render(){
	return (
<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Knowledge Base</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="/vlm" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
								<div class="col">
									<a href="/problem-tickets" class="btn btn-info">My Tickets</a>&nbsp;
									<a href="/create-problem-ticket" class="btn btn-success">New Ticket</a>
								</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="/" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<div class="m-portlet__body  m-portlet__body--no-padding">
							
							<center>
								
								<h4>Knowledge Base Articles</h4>&nbsp;&nbsp;
							</center>
							<div class="row"><a href="#" class="col-sm-12">How to run a virus scan on your device</a></div>
							<div class="row"><a href="#" class="col-sm-12">The first thing to do when you suspect a malware issue</a></div>
							<div class="row"><a href="#" class="col-sm-12">Types of malware</a></div>
							<div class="row"><a href="#" class="col-sm-12">What to do when you get a breach alert</a></div>
							<div class="row"><a href="#" class="col-sm-12">Connecting to your VPN</a></div>
							<div class="row"><a href="#" class="col-sm-12">Reasons for using the DNS service</a></div>
							</div>

						</div>            
					</div>		
	            </div>	
            </div>
            
			</div>
			</div>
			
    );

}
}

